import Vue from "vue";

// axios
import axios from "axios";
const urlApi = [
	'https://api.ugems.id/ucontract/api',
	'https://api.ugems.id/ucontract-dev/api'
];

const axiosIns = axios.create({
	// You can add your headers here
	// ================================
	baseURL: `${process.env.VUE_APP_API_URL}`,
	// timeout: 1000,
	headers: {
		Authorization: `Bearer ${localStorage.getItem("ugems-accessToken")}`,
		"ngrok-skip-browser-warning": !urlApi.includes(process.env.VUE_APP_API_URL),
		"Content-Type": "application/json",
	},
});

axiosIns.interceptors.response.use(
	function (response) {
		return response;
	},
	function (error) {
		if (error.response.status == 401) {
		}
		console.log(`error : ${error.response.status}`);
		return Promise.reject(error);
	}
);

Vue.prototype.$http = axiosIns;

export default axiosIns;
